import { Component } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-date',
  templateUrl: './formly-date.component.html',
  styleUrl: './formly-date.component.scss',
})
export class FormlyDateComponent extends FormlyFieldBaseComponent {
  change() {
    if (this.props.change) {
      this.props.change(this.field, { target: { value: this.field.model[this.key] } });
    }
  }
}
